'use strict';

function groupPremiumOffers(coupons, limit = 1) {
  return coupons.reduce(
    (result, item) => {
      const { premiumList, couponList } = result;

      if (premiumList.length < limit && item.isPremiumOffer) {
        premiumList.push(item);
      } else {
        couponList.push(item);
      }

      return result;
    },
    { premiumList: [], couponList: [] }
  );
}

module.exports = groupPremiumOffers;
